import React, {Component} from "react";
import { Timeline } from "antd";
import dayjs from 'dayjs';

/**
 * Displays all the possible schedules a user can view. It contains one, two, seven and nine day schedules a user can view.
 */
class PostedSchedulesList extends Component {

  getFormattedDate = (startDate) => {
    const splited = startDate.split('/');
    let year =dayjs().year();
    if (dayjs().month()+1 < parseInt(splited[0]) ) {
              year-=1;
    }
    return dayjs(`${year}/${splited[0]}/${splited[1]}`).format('ddd M/D');
  }
  render() {
    const items  =
    this.props.listPostedSchedulesArray.map((elem) =>{
      const { name, startDate } = elem;
      let shortDate = dayjs(startDate).format('ddd M/D')
      let label =shortDate;
      switch(elem.name) {
        case 'postedDayOneId': 
          label = `Today ${shortDate}`; break;
        case 'postedTwoDaysToday':
          label = `Today ${shortDate} 2 days`; break;
        case 'postedTwoDaysTomorrow':
          label = `${shortDate} 2 days`; break;
        case 'savedMd7':
          label = `Posted 7 days ${startDate > '-1' ? this.getFormattedDate(startDate) : ''}`; break;
        case 'savedMd9':
          label = `Posted 9 days ${startDate > '-1' ? this.getFormattedDate(startDate) : ''}`; break;
      }
      return { 
        color:  (elem.id && elem.id !== -1) ? "blue" : "yellow" ,
        children:(
           (elem.id && elem.id > -1)
            ? <a
                onClick={() => {
                  // eslint-disable-next-line
                  (elem.id && elem.id > -1) ? this.props.handleSelectSchedule(elem) : null
                }}
                style={{ color: 'dodgerblue ' }}
              >
                {label}
              </a>
            : label 
        )

      };

    });

    return(
      <Timeline style={{ /* marginBottom: -35 */ }} items = {items}>

      </Timeline>
    );
  }
}

export default PostedSchedulesList;
